import Vue from 'vue';
import Component from 'vue-class-component';
@Component({
  name: 'dropdown-toggle-mixin',
  props: {
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
  },
})
export default class CDropdownToggleMixin extends Vue {
  showDropdown = false;
  closeOnSelect!: boolean;

  hide() {
    this.showDropdown = !this.closeOnSelect;
    if (!this.showDropdown) {
      this.closeDropdown({});
    }
  }

  toggleDropdown(event) {
    // event.preventDefault();
    const ENTER_KEY = 13,
      ESC_KEY = 27,
      SPACE_KEYS = [0, 32];
    if (event.which != 9) {
      !this.showDropdown && this.openDropdown();
    }
    if (event.type === 'click' || event.type == 'focus') {
      // this.showDropdown ? this.closeDropdown(event) : this.openDropdown();
    } else if (event.which === ESC_KEY || event.which === 9) {
      document.body.click();
      event.stopImmediatePropagation();
    } else if (event.which === ENTER_KEY) {
      const option = this.filteredOptions && this.filteredOptions[0];
      option ? this.selectItemHandler(option) : this.saveValue();
      document.body.click();
      event.stopImmediatePropagation();
    }
  }

  closeDropdown(event) {
    const dd = this.$refs.container as HTMLElement;
    if (!dd) return;
    if (dd.contains(event.target)) {
      return;
    }
    this.showDropdown = false;
    this.removeDocListener();
  }

  openDropdown() {
    this.showDropdown = true;
    this.registerEventsAfterToggle();
  }

  registerEventsAfterToggle() {
    window.setTimeout(() => {
      document.addEventListener('click', this.closeDropdown);
      document.addEventListener('keyup', this.escHandler);
    });
  }

  removeDocListener() {
    document.removeEventListener('click', this.closeDropdown);
    document.removeEventListener('keyup', this.escHandler);
  }

  escHandler(event) {
    event.stopImmediatePropagation();
    event.which === 27 && this.closeDropdown(event);
  }

  isFocussable(el) {
    return el.getAttribute('tabindex');
  }

  focusItems() {
    const focussableEl = this.$refs.x1;
    focussableEl &&
      (focussableEl.constructor === Array && focussableEl[0]
        ? focussableEl[0].focus()
        : '');
  }

  navigateDown($event) {
    if ($event.target.nextElementSibling) {
      $event.target.nextElementSibling.focus();
    } else if (
      $event.target.parentElement &&
      $event.target.parentElement.nextElementSibling
    ) {
      const temp = $event.target.parentElement.nextElementSibling;
      const child = temp.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0];
      child && child.focus();
    }
  }

  navigateUp($event) {
    if (
      $event.target.previousElementSibling &&
      this.isFocussable($event.target.previousElementSibling)
    ) {
      $event.target.previousElementSibling.focus();
    } else if (
      $event.target.parentElement &&
      $event.target.parentElement.previousElementSibling
    ) {
      const temp = $event.target.parentElement.previousElementSibling;
      let child = temp.querySelectorAll('[tabindex]:not([tabindex="-1"])');
      if (!child) {
        return;
      }
      child = child[child.length - 1];
      child && child.focus();
    }
  }
}
